// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreCategory = (client) => ({
    /**
     * `GET /store/categories`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetCategories
     * @source packages/modules/b2c-core/src/api/store/categories/route.ts
     */
    getList: (query, headers) => client.fetch("/store/categories", { method: "GET", query, headers }),
});
//# sourceMappingURL=categories.js.map